const exportStatuses = {
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Complete',
  ERROR: 'Failed',
};

export default exportStatuses;
